import React, { useContext } from 'react';

import styled from '@emotion/styled';

import useCreateThirdPartyAccess from '../../../../hooks/dashboard/settings/useCreateThirdPartyAccess';
import {
  AddThirdPartyAccessInitialValues,
  AddThirdPartyAccessInterface,
  AddThirdPartyAccessSchema,
} from '../../../../models/dashboard/settings/third-party-access.model';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { FormComponent } from '../../../FormCom/FormComponent';
import { TextInputField } from '../../../FormCom/FormField';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface AddThirdPartyAccessModalProps {
  onSuccess?: () => void;
}

const AddThirdPartyAccessModal: React.FC<AddThirdPartyAccessModalProps> = ({
  onSuccess,
}) => {
  const modalContext = useContext(ModalContext);
  const { createThirdPartyAccess, loading } = useCreateThirdPartyAccess();

  const onSubmit = (values: AddThirdPartyAccessInterface) => {
    createThirdPartyAccess(values, () => {
      modalContext?.setShowModal(false);
      onSuccess && onSuccess();
    });
  };

  return (
    <ModalContainer
      label='Add Third-party Access'
      description="We'll email them a link to generate their own key."
    >
      <FormComponent
        initialValues={AddThirdPartyAccessInitialValues}
        schema={AddThirdPartyAccessSchema}
        onSubmit={onSubmit}
      >
        <TextInputField
          type='text'
          label='Name'
          name='name'
          id='name'
          placeholder='e.g. Fleet Ops – Lagos'
        />

        <TextInputField
          type='email'
          label='Contact Email'
          name='email'
          id='email'
          placeholder='e.g. ops@fleetco.com'
        />

        <TextInputField
          type='date'
          label='Date of Expiry'
          name='expiresAt'
          id='expiresAt'
          placeholder='Select date of expiry'
        />

        <ButtonArea>
          <FormSubmitButton
            className='clear fill'
            onClick={() => modalContext?.setShowModal(false)}
            btnType='button'
          >
            Cancel
          </FormSubmitButton>
          <FormSubmitButton className='fill' loading={loading}>
            Save
          </FormSubmitButton>
        </ButtonArea>
      </FormComponent>
    </ModalContainer>
  );
};

export default AddThirdPartyAccessModal;

const ButtonArea = styled.div`
  display: flex;
  gap: 16px;
`;
